import React, { Component } from "react";
import { Link } from "react-router-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import classNames from "classnames";
import LoadingBar from "react-redux-loading-bar";

import { clearCache } from "SignupActions";
import SignupCreate from "./steps/signupcreate";
import SignupVerify from "./steps/signupverify";
import SignupFeatures from "./steps/signupfeatures";
import SignupDashboard from "./steps/signupfinish";
import StepComplete from "./steps/icons/stepcomplete";
import StepPending from "./steps/icons/steppending";
import LoginErrorBar from "./errorbar";

export var STEP_CREATE = "create";
export var STEP_VERIFY = "verify";
export var STEP_CHOOSE = "choose";
export var STEP_FINISH = "finish";

class Signup extends Component {
  constructor(props) {
    super(props);
    this.onSignupCreateCallback = this.onSignupCreateCallback.bind(this);
    this.onSignupVerifyCallback = this.onSignupVerifyCallback.bind(this);
    this.onSignupChooseCallback = this.onSignupChooseCallback.bind(this);
    this.onSignupFinishCallback = this.onSignupFinishCallback.bind(this);
  }

  onSignupCreateCallback() {
    var updatedStyles = this.state.styles;
    // updatedStyles[0]=classNames('step-icon','step-icon-pending');
    updatedStyles[0] = classNames("step-icon", "step-icon-completed");
    updatedStyles[1] = classNames("step-icon", "step-icon-selected");

    var stepcontents = this.state.stepcontent;
    stepcontents[0] = <StepComplete />;

    this.setState({
      step: STEP_VERIFY,
      activeComponent: <SignupVerify callback={this.onSignupVerifyCallback} />,
      styles: updatedStyles,
      stepcontent: stepcontents,
    });
  }

  onSignupVerifyCallback() {
    var updatedStyles = this.state.styles;
    updatedStyles[1] = classNames("step-icon", "step-icon-completed");
    updatedStyles[2] = classNames("step-icon", "step-icon-selected");

    var stepcontents = this.state.stepcontent;
    stepcontents[1] = <StepComplete />;

    this.setState({
      step: STEP_CHOOSE,
      activeComponent: (
        <SignupFeatures callback={this.onSignupChooseCallback} />
      ),
      styles: updatedStyles,
      stepcontent: stepcontents,
    });
  }

  onSignupChooseCallback() {
    var updatedStyles = this.state.styles;
    updatedStyles[2] = classNames("step-icon", "step-icon-completed");

    var stepcontents = this.state.stepcontent;
    stepcontents[2] = <StepComplete />;

    this.setState({
      step: STEP_FINISH,
      activeComponent: (
        <SignupDashboard callback={this.onSignupFinishCallback} />
      ),
      styles: updatedStyles,
      stepcontent: stepcontents,
    });
  }

  onSignupFinishCallback(event) {
    //this.props.dispatch(loginToApp(true));
    this.props.history.push("/dashboard");
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.moveToDashboard === true) {
      this.props.history.push("/dashboard");
    }

    if (this.props.isLoggedIn === true) {
      this.props.history.push("/dashboard");
    }

    if (this.props.moveToLogin === true) {
      this.props.history.push("/login");
    }
  }

  render() {
    if (this.props.moveToLogin === true) {
      this.props.history.push("/login");
    }

    var activeComponent = <SignupCreate />;
    var signupformStyle = classNames(
      "col-md-6",
      "signup-form-elements-container"
    );
    var styles = [
      classNames("step-icon", "step-icon-selected"),
      classNames("step-icon", "step-icon-disabled"),
      classNames("step-icon", "step-icon-disabled"),
    ];
    var stepcontents = ["1", "2", "3"];

    if (this.props.signupStep === STEP_VERIFY) {
      activeComponent = <SignupVerify />;

      styles[0] = classNames("step-icon", "step-icon-completed");
      styles[1] = classNames("step-icon", "step-icon-selected");

      stepcontents[0] = <StepComplete />;
    } else if (this.props.signupStep === STEP_CHOOSE) {
      activeComponent = <SignupFeatures />;

      signupformStyle = classNames(
        "col-md-12",
        "signup-form-elements-container",
        "signup-features-container"
      );

      styles[0] = classNames("step-icon", "step-icon-completed");
      styles[1] = classNames("step-icon", "step-icon-completed");
      styles[2] = classNames("step-icon", "step-icon-selected");

      stepcontents[0] = <StepComplete />;
      stepcontents[1] = <StepComplete />;
    } else if (this.props.signupStep === STEP_FINISH) {
      activeComponent = <SignupDashboard />;

      signupformStyle = classNames("col-md-12", "container-nomargin");

      styles[0] = classNames("step-icon", "step-icon-completed");
      styles[1] = classNames("step-icon", "step-icon-completed");
      styles[2] = classNames("step-icon", "step-icon-completed");

      stepcontents[0] = <StepComplete />;
      stepcontents[1] = <StepComplete />;
      stepcontents[2] = <StepComplete />;
    }

    return (
      <div className="full-height signup-background">
        <div className="signup-bar">
          <img
            src="../../style/images/Logo-Color.png"
            id="header-logo"
            className="horizontal-align-center"
            alt="Logo-Color"
          />{" "}
          <Link to="/" className="pull-right login-close-button">
            <img src="../../style/images/blue-close.png" alt="blue-close" />
          </Link>
        </div>
        <div style={{ height: "3px", position: "relative" }}>
          <LoadingBar
            style={{
              backgroundColor: "#4da1ff",
              height: "3px",
              position: "absolute",
              zIndex: 9999,
              width: "100%",
            }}
            showFastActions
            maxProgress={100}
          />
        </div>
        <div className="signup-container">
          <div className="row">
            <div className="col-md-2" />
            <div className="col-md-8 signup-steps">
              <ul className="list-inline">
                <li className="col-md-2">
                  <p className={styles[0]}>{stepcontents[0]}</p>
                  <p className="step-label">Create Account</p>
                </li>
                <li className="col-md-3">
                  <hr className="step-hr" />
                </li>
                <li className="col-md-2">
                  <p className={styles[1]}>{stepcontents[1]}</p>
                  <p className="step-label">Verification</p>
                  <p className="step-label">{/*Choose Features*/}</p>
                </li>
                <li className="col-md-3">
                  <hr className="step-hr" />
                </li>
                <li className="col-md-2">
                  <p className={styles[2]}>{stepcontents[2]}</p>
                  <p className="step-label">Choose Features</p>
                  <p className="step-label">{/*Dashboard*/}</p>
                </li>
              </ul>
            </div>
            <div className="col-md-2" />
          </div>
          <div className="row">
            <div className="col-md-2">&nbsp;</div>
            <div className="col-md-8 signup-form-container">
              {this.props.signupStep === STEP_CREATE ||
              this.props.signupStep === STEP_VERIFY ? (
                <div className="row">
                  <div className="col-md-1">&nbsp;</div>
                  <div className={signupformStyle}>{activeComponent}</div>
                  <div className="col-md-1">&nbsp;</div>

                  <div className="col-md-4 col-signup-desc">
                    <div className="signup-description">
                      <div className="signup-description-bg"></div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className={signupformStyle}>{activeComponent}</div>
                </div>
              )}
            </div>
            <div className="col-md-2">&nbsp;</div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({
  signupStep,
  moveToDashboard,
  isLoggedIn,
  moveToLogin,
  fromLogin,
}) {
  return {
    signupStep,
    moveToDashboard,
    isLoggedIn,
    moveToLogin,
    fromLogin,
  };
}

export default connect(mapStateToProps, { clearCache })(Signup);
